// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import DurationIcon from '../../../assets/images/card-time-icon.svg';
import LabIcon from '../../../assets/images/card-lab-icon.svg';
import QuizIcon from '../../../assets/images/card-assessment-icon.svg';
import VodIcon from '../../../assets/images/card-vod-icon.svg';
import LanguageIcon from '../../../assets/images/card-language-icon.svg';
import LevelIcon from '../../../assets/images/card-level-icon.svg';
import ChallengeIcon from '../../../assets/images/challenge-icon-in-card.svg';
import TotalQuestionIcon from '../../../assets/images/card-total-question-icon.svg';
import LocationIcon from '../../../assets/images/location-icon.svg';

export enum InfoTextType {
  DURATION,
  HIGHTLIGHTDURATION,
  VOD,
  LAB,
  ASSESSMENT,
  LEVEL,
  LANGUAGE,
  CHALLENGE,
  EXAM,
  EXAMMULTISELECT,
  EXAMQA,
  LOCATION
}

const InfoText:React.FC<{ type: InfoTextType }> = ({ type, children, ...props }) => {
  switch (type) {
    case InfoTextType.DURATION:
      return <div {...props} ><img src={DurationIcon} alt="duration-icon" />{children}</div>
    case InfoTextType.HIGHTLIGHTDURATION:
      return <div {...props} >{children}</div>
    case InfoTextType.LAB:
      return <div {...props} ><img src={LabIcon} alt="lab-icon" />{children}</div>
    case InfoTextType.VOD:
      return <div {...props} ><img src={VodIcon} alt="vod-icon" />{children}</div>
    case InfoTextType.ASSESSMENT:
      return <div {...props} ><img src={QuizIcon} alt="quiz-icon" />{children}</div>
    case InfoTextType.LANGUAGE:
      return <div {...props} ><img src={LanguageIcon} alt="language-icon" />{children}</div>
    case InfoTextType.LEVEL:
      return <div {...props} ><img src={LevelIcon} alt="level-icon" />{children}</div>
    case InfoTextType.CHALLENGE:
      return <div {...props} ><img src={ChallengeIcon} alt="challenge-icon" />{children}</div>
    case InfoTextType.EXAMMULTISELECT:
      return <div {...props} ><img src={TotalQuestionIcon} alt="multi-select-icon" />{children}</div>
    case InfoTextType.EXAM:
    case InfoTextType.EXAMQA:
      return <div {...props} ><img src={QuizIcon} alt="qa-icon" />{children}</div>
    case InfoTextType.LOCATION:
      return <div {...props} ><img src={LocationIcon} alt="location-icon" />{children}</div>
    default:
      return null;
  }
}

export { InfoText as default};
